import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService } from 'kea-resource';

const controller = rpcController("Camion");
const crud = rpcCrudService<models.Camion, models.CamionDTO>(controller);

export const Camion = cacheResource({
    ...crud,
    /**Consulta los status de un camión */
    ConsultarStatus: async (filtro: models.FiltroStatusCamion): Promise<models.StatusCamionRutaViewDto[]> => await controller('ConsultarStatus', {}, filtro),

    /**Asigna un camión a una sucursal */
    AsignarSucursal: async (idCamion: number, idSucursal: number): Promise<void> => await controller('AsignarSucursal', { idCamion, idSucursal }),
}, {
        getMemo: true,
        query: true
    }, {
        add: true,
        delete: true,
        update: true,
        AsignarSucursal: true
    });




// WEBPACK FOOTER //
// ./app/resources/items/camion.tsx